<h2 mat-dialog-title>{{'packages.installedApps.resetHighscore' | translate}}</h2>

<mat-dialog-content>

  <data-table (custom)="onReset($event)"
                  *ngIf="uuids && uuids.length && isTouch2015"
                  [columns]="columns"
                  [dataProviderParams]="paramsScreen"
                  [dataProvider]="angieScreenService"
                  [hideSearch]="true"
                  [icon]="'settings_backup_restore'"
                  [title]="'Screens'"
  ></data-table>

  <data-table (custom)="onReset($event)"
                  *ngIf="uuids && uuids.length && !isTouch2015"
                  [columns]="columns"
                  [dataProviderParams]="paramsScreen"
                  [dataProvider]="packageService"
                  [hideSearch]="true"
                  [icon]="'settings_backup_restore'"
                  [title]="'Screens'"
  ></data-table>

  <p *ngIf="!uuids || !uuids.length">{{'general.noContentAvailable' | translate}}</p>

</mat-dialog-content>

<mat-dialog-actions>
  <div class="buttons">
    <button (click)="dialogRef.close()" class="ibexfusion-raised-button"
            mat-button>{{'general.close' | translate}}</button>
  </div>
</mat-dialog-actions>


